import { $post, $get, dealError } from "@/utils"
import { router } from "../router"
import { setToken } from "../utils/tools"
import store from "./index"
import { GET_ADDRESS_LIST } from "@tt/api"
let loading = false;
let init = false;
const addressManage = {
  state: {
    _addressList: []
  },
  mutations: {
    SET_ADDRESSLIST(state, data) {
      state._addressList = data;
    },
    SET_DEFAULT(state, id){
      const res = state._addressList.map(item=> {
        if(item.id === id){
          return {
            ...item,
            isDefault: true
          }
        }
        return {
          ...item,
          isDefault: false
        }
      })
      state._addressList = res;
    }
  },
  getters: {
    addressList(state) {
      if (!state._addressList.length && !init){
        store.dispatch("getAddressList")
      }
      return state._addressList;
    }
  },
  actions: {
    getAddressList({commit}) {
      return new Promise((resolve, reject) => {
        if (loading) return;
        loading = true;
        GET_ADDRESS_LIST().then(({data})=> {
          loading = false;
          init = true;
          const res = data.map(item => {
            const { phone, default: isDefault,...ret } = item;
            return {
              ...ret,
              tel: phone,
              isDefault,
              info: `${item.name}(${phone})`
            }
          })
          commit("SET_ADDRESSLIST", res)
          resolve(res)
        }).catch(e=> {
          loading = false;
          dealError(e)
          reject(e)
        })
      })
    },
  },
}
export default addressManage
